import { gql } from '@apollo/client';

import { createApolloClient } from '@/apolloClient';
import parseJwt from '@/helpers/common';
import { logError } from '@/helpers/logger/logUtils';

import type { UserProfileResponse, VoyageData } from './loadStrings';

const USER_PROFILE = gql`
  query UserProfile {
    userProfileDirect {
      userGUID
      guestId
      birthDate
      personId
      personTypeCode
      isPasswordExist
      userMediaItemId
      addresses {
        countryCode
        city
        line1
        line2
        zip
        stateCode
      }
      userBookingHistory {
        reservationNumber
        status
        embarkDate
        debarkDate
        embarkPortCode
        debarkPortCode
        guestId
        isDeleted
        connectedBooking
        guestTypeCode
      }
      userBookings {
        reservationNumber
        status
        embarkDate
        debarkDate
        embarkPortCode
        debarkPortCode
        guestId
        isDeleted
        connectedBooking
        guestTypeCode
      }
      userNotifications {
        userNotificationId
        notificationTypeCode
        IsOptInForEmail
        IsOptInForSMS
        IsOptInForCall
        isDeleted
      }
      isDeleted
      emailVerificationStatus
      externalRefId
      updateBySeawareClientId
      badges
      firstName
      lastName
      preferredName
      genderCode
      email
      citizenshipCountryCode
      phoneCountryCode
      phoneNumber
    }
  }
`;

export type ProfileBooking = {
  connectedBooking: boolean;
  debarkDate: string;
  debarkPortCode: string;
  embarkDate: string;
  embarkPortCode: string;
  guestId: string;
  guestTypeCode: string;
  isDeleted: boolean;
  reservationNumber: string;
  status: string;
};

export type ProfileNotification = {
  IsOptInForCall?: boolean;
  IsOptInForEmail?: boolean;
  IsOptInForSMS?: boolean;
  notificationTypeCode: 'PO' | 'NO' | 'GIT';
  userNotificationId: string;
  isDeleted: boolean;
};

export const loadUserProfile = async (baseUrl: string, token: string): Promise<UserProfileResponse | null> => {
  try {
    const client = createApolloClient(baseUrl, token);
    const { data } = await client.query<VoyageData>({ query: USER_PROFILE });
    return data.userProfileDirect || null;
  } catch (error) {
    if (error instanceof Error) {
      const jwt = parseJwt(token);
      logError(`UserProfileDirect: ${error.message}. (${jwt.userGUID}:${jwt.exp})`);
    } else {
      logError('UserProfileDirect: Unexpected error');
    }
    return null;
  }
};
